module.exports = __webpack_public_path__ + "img/logo-camp-original-icone.74fcfedf.png";